// extracted by mini-css-extract-plugin
export var carrierTab = "_59-0";
export var carrierTabActive = "_59-1 _59-0";
export var carrierTabInactive = "_59-2 _59-0";
export var carrierTabLabel = "_59-3";
export var carrierTabLabelActive = "_59-4 _59-3";
export var carrierTabLabelInactive = "_59-5 _59-3";
export var carrierTabPercentage = "_59-6";
export var carrierTabPercentageActive = "_59-7 _59-6";
export var carrierTabPercentageInactive = "_59-8 _59-6";
export var carrierTabWinnable = "_59-9";
export var carrierTabWinnableActive = "_59-a _59-9";
export var carrierTabWinnableInactive = "_59-b _59-9";
export var comparisonContainer = "_59-d";
export var missingRateButton = "_59-n";
export var missingRateButtonActive = "_59-o _59-n";
export var missingRateButtonInactive = "_59-p _59-n";
export var missingRateButtonLabel = "_59-q";
export var missingRateButtonLabelActive = "_59-r _59-q";
export var missingRateButtonLabelInactive = "_59-s _59-q";
export var sidebar = "_59-c";
export var strategyButton = "_59-e";
export var strategyButtonActive = "_59-f _59-e";
export var strategyButtonDescription = "_59-k";
export var strategyButtonDescriptionActive = "_59-l _59-k";
export var strategyButtonDescriptionInactive = "_59-m _59-k";
export var strategyButtonInactive = "_59-g _59-e";
export var strategyButtonLabel = "_59-h";
export var strategyButtonLabelActive = "_59-i _59-h";
export var strategyButtonLabelInactive = "_59-j _59-h";
export var unitToggleButton = "_59-t";
export var unitToggleButtonActive = "_59-u _59-t";
export var unitToggleButtonInactive = "_59-v _59-t";
export var unitToggleButtonLabel = "_59-w";
export var unitToggleButtonLabelActive = "_59-x _59-w";
export var unitToggleButtonLabelInactive = "_59-y _59-w";